import React, { Component } from 'react'
// import { Link } from "react-router-dom";
import ReactModal from 'react-modal'
import membersOnly from '../assets/images/members-only.svg'
import { withRouter } from '../utils/routerCompat'
import { subscriptionPlanFor } from '../helper/isLegacyUser'
import { BOOK_LIMIT_FEATURE } from '../utils/bookLimit'

ReactModal.setAppElement('body')

class UpgradePopup extends Component {
  _closePopup = async () => {
    const { popupControl, publishPrivate, ctaText } = this.props
    if (publishPrivate && ctaText !== 'Close') publishPrivate('PRIVATE')
    popupControl(false)
  }

  _closeModal = async () => {
    const { popupControl } = this.props
    popupControl(false)
  }

  _becomeAMember = async () => {
    const { popupControl } = this.props
    // TODO: Arman, maybe you can make this better? I want to save it as Private journal(it's better if it's draft too) before take user to the Billing page
    this.props.history.push({ pathname: '/my-account/billing' })
    popupControl(false)
  }

  render() {
    const { featureName, showUpgrade, ctaText, userCreatedAt } = this.props
    const isBookLimit = featureName === BOOK_LIMIT_FEATURE
    const plan = subscriptionPlanFor(userCreatedAt)

    return (
      <div>
        <ReactModal
          isOpen={showUpgrade}
          contentLabel="Member's only feature"
          onRequestClose={this._closeModal}
          style={{ overlay: { background: 'rgba(0, 0, 0, 0.7' } }}
          className="modal-box"
        >
          <img
            src={membersOnly}
            alt="Become a member!"
            style={{ maxHeight: '180px' }}
          />
          {isBookLimit ? (
            <>
              <h1>You've filled your 3 free journal books</h1>
              <p>
                Upgrade to create unlimited books, download a backup of all your
                journals, and join the community when you're ready.{' '}
                <span style={{ whiteSpace: 'nowrap' }}>{`$${plan.monthly}/mo`}</span> or{' '}
                <span style={{ whiteSpace: 'nowrap' }}>{`$${plan.annual}/yr.`}</span>
              </p>
            </>
          ) : (
            <>
              <h1>{featureName} is member's only feature</h1>
              <p>
                Your membership helps us out a lot! Support the community by
                becoming a member and get full access to all features.
              </p>
            </>
          )}
          {/* TODO: Save the journal as a private then take user to the Billing page */}
          <p>
            <button onClick={this._becomeAMember} id="Upgrade to member">
              {isBookLimit ? 'See plans' : 'Become a member now'}
            </button>
          </p>{' '}
          {/* TODO: Save the journal as a private */}
          {ctaText && (
            <p>
              <small>
                <button
                  className="link-btn"
                  onClick={this._closePopup}
                  id="Upgrade close popup"
                >
                  {isBookLimit ? 'Not now' : ctaText}
                </button>
              </small>
            </p>
          )}{' '}
        </ReactModal>
      </div>
    )
  }
}

export default withRouter(UpgradePopup)
